export const categories = [
    {
      id: "B1T00",
      name: "B1 words",
      description:
        "Common English words at the B1 intermediate level, useful for everyday communication.",
      exampleUsage: "I usually eat breakfast at 7 a.m.",
      difficulty: "Intermediate",
      typicalTest: "CEFR B1",
      img: "https://i.pinimg.com/736x/e4/82/95/e48295f4d9d4949f695090ff17e34c5f.jpg"
    },
    {
      id: "B2P77",
      name: "B2 words",
      description:
        "More advanced vocabulary for upper-intermediate learners, including abstract and academic words.",
      exampleUsage:
        "She demonstrated excellent leadership skills in the project.",
      difficulty: "Upper-Intermediate",
      typicalTest: "CEFR B2",
      img: "https://i.pinimg.com/736x/eb/04/f7/eb04f79ee3493459b3e8ce04b11edf10.jpg"
    },
    {
      id: "C1K44",
      name: "C1 words",
      description:
        "Advanced vocabulary often used in professional and academic contexts.",
      exampleUsage: "His eloquent speech impressed all the attendees.",
      difficulty: "Advanced",
      typicalTest: "CEFR C1",
      img: "https://i.pinimg.com/736x/c6/c1/de/c6c1de944ea366f011f7a4b43c8db8cd.jpg"
    },
    {
      id: "C2F11",
      name: "C2 words",
      description:
        "Highly sophisticated vocabulary suitable for near-native or academic proficiency.",
      exampleUsage:
        "The intricate nuances of the argument were difficult to grasp.",
      difficulty: "Proficient",
      typicalTest: "CEFR C2",
      img: "https://i.pinimg.com/736x/9d/eb/b3/9debb3810aa8beb982e6acc43bd3fac1.jpg"
    },
    {
      id: "EVERYDAY32",
      name: "Everyday words",
      description:
        "Commonly used words that are slightly challenging but useful for daily conversations.",
      exampleUsage: "I need to schedule a meeting for tomorrow afternoon.",
      difficulty: "Intermediate",
      typicalTest: "General English",
      img: "https://i.pinimg.com/736x/0d/ac/73/0dac732c01c663ec029595fc3d324f7d.jpg"
    },
    {
      id: "TOEFL54",
      name: "TOEFL words",
      description:
        "Academic and formal vocabulary commonly tested on the TOEFL exam.",
      exampleUsage:
        "The research findings were inconclusive due to insufficient data.",
      difficulty: "Advanced Academic",
      typicalTest: "TOEFL",
      img: "https://i.pinimg.com/736x/5a/fb/fd/5afbfdef4cd765798281c6df90fefb40.jpg"
    },
    {
      id: "IELTS76",
      name: "IELTS words",
      description:
        "Vocabulary tailored for the IELTS exam, covering academic and general English contexts.",
      exampleUsage:
        "The government should invest more in renewable energy sources.",
      difficulty: "Upper-Intermediate to Advanced",
      typicalTest: "IELTS",
      img: "https://i.pinimg.com/736x/7e/09/5c/7e095c235128eaa6eea5d89188ef16e0.jpg"
    },
    {
      id: "IDIOMS98",
      name: "Idioms & Expressions",
      description:
        "Common English idioms and expressions used in everyday conversations.",
      exampleUsage: "Don’t worry, I was just pulling your leg.",
      difficulty: "Intermediate to Advanced",
      typicalTest: "General English",
      img: "https://i.pinimg.com/736x/1b/87/54/1b8754a9bb0c975f784b42d40e068560.jpg"
    },
    {
      id: "EMOTIONS09",
      name: "Emotions & Feelings",
      description:
        "Words and phrases that describe human emotions and feelings.",
      exampleUsage: "She felt overwhelmed by the joyful news.",
      difficulty: "All Levels",
      typicalTest: "General English",
      img: "https://i.pinimg.com/736x/1e/0b/a6/1e0ba6dd3b1569a97d6de7c049bcb6fb.jpg"
    },
  ];